var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "expand_circle_down"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_323_649",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_323_649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand_circle_down_2",
    d: "M7.99992 10.3335L10.9999 7.3335L10.0499 6.40016L7.99992 8.45016L5.94992 6.40016L4.99992 7.3335L7.99992 10.3335ZM7.99992 14.6668C7.0777 14.6668 6.21103 14.4918 5.39992 14.1418C4.58881 13.7918 3.88325 13.3168 3.28325 12.7168C2.68325 12.1168 2.20825 11.4113 1.85825 10.6002C1.50825 9.78905 1.33325 8.92238 1.33325 8.00016C1.33325 7.07794 1.50825 6.21127 1.85825 5.40016C2.20825 4.58905 2.68325 3.8835 3.28325 3.2835C3.88325 2.6835 4.58881 2.2085 5.39992 1.8585C6.21103 1.5085 7.0777 1.3335 7.99992 1.3335C8.92214 1.3335 9.78881 1.5085 10.5999 1.8585C11.411 2.2085 12.1166 2.6835 12.7166 3.2835C13.3166 3.8835 13.7916 4.58905 14.1416 5.40016C14.4916 6.21127 14.6666 7.07794 14.6666 8.00016C14.6666 8.92238 14.4916 9.78905 14.1416 10.6002C13.7916 11.4113 13.3166 12.1168 12.7166 12.7168C12.1166 13.3168 11.411 13.7918 10.5999 14.1418C9.78881 14.4918 8.92214 14.6668 7.99992 14.6668ZM7.99992 13.3335C9.48881 13.3335 10.7499 12.8168 11.7833 11.7835C12.8166 10.7502 13.3333 9.48905 13.3333 8.00016C13.3333 6.51127 12.8166 5.25016 11.7833 4.21683C10.7499 3.1835 9.48881 2.66683 7.99992 2.66683C6.51103 2.66683 5.24992 3.1835 4.21659 4.21683C3.18325 5.25016 2.66659 6.51127 2.66659 8.00016C2.66659 9.48905 3.18325 10.7502 4.21659 11.7835C5.24992 12.8168 6.51103 13.3335 7.99992 13.3335Z",
    fill: "#D2D3D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandCircleDown);
export default __webpack_public_path__ + "static/media/expand_circle_down.33bb99c86ada6099436f533fe6c5661e.svg";
export { ForwardRef as ReactComponent };